
import { BusinessLandingSettings, defaultLandingSettings } from "@/types/businessLanding";
import { useSaasInstance } from "@/hooks/useSaasInstance";

// Get business landing settings
export const getBusinessLandingSettings = async (businessId: string): Promise<BusinessLandingSettings> => {
  // In a real implementation, this would fetch from an API
  return new Promise((resolve) => {
    setTimeout(() => {
      // Try to get from localStorage first
      const savedSettings = localStorage.getItem(`landingSettings_${businessId}`);
      if (savedSettings) {
        resolve(JSON.parse(savedSettings));
      } else {
        // Use default settings if none found
        const settings = { 
          ...defaultLandingSettings, 
          businessId 
        };
        localStorage.setItem(`landingSettings_${businessId}`, JSON.stringify(settings));
        resolve(settings);
      }
    }, 500);
  });
};

// Save business landing settings
export const saveBusinessLandingSettings = async (settings: BusinessLandingSettings): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      localStorage.setItem(`landingSettings_${settings.businessId}`, JSON.stringify(settings));
      resolve();
    }, 500);
  });
};

// Get the current business ID based on domain
export const getCurrentBusinessId = (): string => {
  const { isSaasInstance, instanceName } = useSaasInstance();
  
  if (isSaasInstance && instanceName) {
    return instanceName;
  }
  
  // Check if we have a custom domain mapping
  // In a real implementation, this would check a database of domain mappings
  const hostname = window.location.hostname;
  
  // For demo purposes, we'll return a mock ID
  return "default-business";
};
